module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-27.01afd353.png";